// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import { shuffle } from 'helpers/shuffle';
import { Component } from './component';
import fireCustomEvent from './fireCustomEvent';

const symbolClasses = {
    upper: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    lower: 'abcdefghijklmnopqrstuvwxyz',
    number: '0123456789',
    special: '!@#$%^&*?_~',
};

export class PasswordGenerator extends Component {
    _initConfiguration(config) {
        super._initConfiguration({ tag: 'span', ...config });
        this._passwordElement = document.getElementById(this._getConfigParam('password', null));
        this._generateButtonElement = document.getElementById(this._getConfigParam('generateButton', null));
        this._generateButtonElement.addEventListener('click', this._onGeneratePasswordClick.bind(this));
        this._showButtonElement = document.getElementById(this._getConfigParam('showButton', null));
        this._showButtonElement.addEventListener('click', this._onShowPasswordClick.bind(this));
        this._showPasswordVisible = true;
        this._showPasswordTitle = this._getConfigParam('showPasswordTitle', '');
        this._hidePasswordTitle = this._getConfigParam('hidePasswordTitle', '');
        this._passwordStrength = this._getConfigParam('passwordStrength', '');
    }

    _onGeneratePasswordClick() {
        const password = this._generatePassword();
        this._passwordElement.value = password;

        const passwordConfirmationElement = document.getElementById(this._getConfigParam('passwordConfirmation'));

        if (passwordConfirmationElement) {
            passwordConfirmationElement.value = password;
        }

        fireCustomEvent(this._passwordElement, 'plesk:passwordGenerated');
    }

    _onShowPasswordClick() {
        if (this._showPasswordVisible) {
            this._passwordElement.setAttribute('type', 'text');
            this._showButtonElement.innerHTML = this._hidePasswordTitle;
        } else {
            this._passwordElement.setAttribute('type', 'password');
            this._showButtonElement.innerHTML = this._showPasswordTitle;
        }
        this._showPasswordVisible = !this._showPasswordVisible;
    }

    _generatePassword() {
        let password = '';
        const requiredClasses = ['upper', 'lower', 'lower', 'lower', 'number', 'number', 'special', 'number', 'number'];

        if ('Stronger' === this._passwordStrength) {
            requiredClasses.push('upper', 'upper', 'lower', 'lower', 'lower', 'lower', 'lower', 'lower');
        }

        const shuffledRequiredClasses = shuffle(requiredClasses);

        shuffledRequiredClasses.forEach(i => {
            password += this._generateSymbol(i);
        });
        return password;
    }

    _generateSymbol(symbolClass) {
        const randomValue = crypto.getRandomValues(new Uint32Array(1))[0];
        const index = randomValue % symbolClasses[symbolClass].length;
        return symbolClasses[symbolClass][index];
    }
}
